import { api } from "./api";

export const resourceCategoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllResourceCategoryPagination: builder.mutation({
      query: (data) => ({
        url: "/resourceCategory/getAllResourceCategoryPagination",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ResourceCategory"],
    }),
    getAllResourceCategories: builder.query({
      query: () => ({
        url: "/resourceCategory/getAll",
        method: "GET",
      }),
      providesTags: ["ResourceCategory"],
    }),
    getResourceCategoryById: builder.query({
      query: (id) => ({
        url: `/resourceCategory/get/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "ResourceCategory", id }],
    }),
    saveResourceCategory: builder.mutation({
      query: (data) => ({
        url: "/resourceCategory/saveResourceCategory",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ResourceCategory"],
    }),
    updateResourceCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/resourceCategory/update/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "ResourceCategory", id }, "ResourceCategory"],
    }),
    deleteResourceCategory: builder.mutation({
      query: (id) => ({
        url: `/resourceCategory/delete/${id}`,
        method: "PUT",
      }),
      invalidatesTags: ["ResourceCategory"],
    }),
  }),
});

export const {
  useGetAllResourceCategoryPaginationMutation,
  useGetAllResourceCategoriesQuery,
  useLazyGetAllResourceCategoriesQuery,
  useGetResourceCategoryByIdQuery,
  useLazyGetResourceCategoryByIdQuery,
  useSaveResourceCategoryMutation,
  useUpdateResourceCategoryMutation,
  useDeleteResourceCategoryMutation,
} = resourceCategoryApi;
